import type { ProductDetailPageFragmentFragment } from "@commerce-frontend/types";
import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import { iconNames } from "@commerce-frontend/ui/icons.generated";
import { useTranslations } from "next-intl";

type Props = {
	instructions: ProductDetailPageFragmentFragment["instructions"];
};

export const ProductInstructions = ({ instructions }: Props) => {
	const t = useTranslations("ProductInstructions");
	const icons = new Set(iconNames);

	const isValidIcon = (key: string): key is (typeof iconNames)[number] => {
		return icons.has(key as (typeof iconNames)[number]);
	};

	return (
		<div className="lg:w-1/2">
			<div className="size-12 bg-gray-100 flex items-center justify-center rounded-full mb-2xl">
				<Icon icon="stars-02" />
			</div>
			<h3 className="display-xs mb-2xl font-semibold lg:display-sm">{t("title")}</h3>
			<p className="text-gray-600 mb-4xl lg:text-lg">{t("subtitle")}</p>
			<div className="grid grid-cols-2 gap-xl lg:grid-cols-3">
				{instructions?.map((instruction, index) => {
					if (!instruction?.key) return;
					const iconKey = isValidIcon(instruction.key) ? instruction.key : null;
					return (
						<div key={index} className="flex flex-col items-center">
							{iconKey ? (
								<Icon icon={iconKey} className="size-16" />
							) : (
								<Icon icon="info-circle" className="w-8 h-16" />
							)}
							<p className="text-sm text-center">{instruction.label}</p>
						</div>
					);
				})}
			</div>
		</div>
	);
};
